// Field palette — defines every field type available in the Form Builder.
// Adding a new type means: (a) append here, (b) handle render in PortalField,
// (c) handle validation in PortalRequestFormPage. Backend already accepts
// any type in FIELD_TYPES (see serviceDesk.js).
import {
  TextAa, TextAlignLeft, Hash, ListBullets, CheckSquare,
  RadioButton, Calendar, EnvelopeSimple, Link as LinkIcon, Paperclip, ListChecks,
  TextT, Flag,
} from '@phosphor-icons/react';

export const FIELD_PALETTE = [
  { type: 'priority',    label: 'Priority',         Icon: Flag,           description: 'Pick list — lets the customer set the request priority' },
  { type: 'text',        label: 'Short text',       Icon: TextAa,         description: 'Single-line text input' },
  { type: 'textarea',    label: 'Long text',        Icon: TextAlignLeft,  description: 'Multi-line text area' },
  { type: 'richtext',    label: 'Rich text',        Icon: TextT,          description: 'Formatted text — bold, highlight, links' },
  { type: 'number',      label: 'Number',           Icon: Hash,           description: 'Numeric input with min/max' },
  { type: 'email',       label: 'Email',            Icon: EnvelopeSimple, description: 'Email address with validation' },
  { type: 'url',         label: 'URL',              Icon: LinkIcon,       description: 'Link / web address' },
  { type: 'date',        label: 'Date',             Icon: Calendar,       description: 'Date picker' },
  { type: 'select',      label: 'Dropdown',         Icon: ListBullets,    description: 'Single-choice from a list' },
  { type: 'multiselect', label: 'Multi-select',     Icon: ListChecks,     description: 'Multiple choices from a list' },
  { type: 'radio',       label: 'Radio buttons',    Icon: RadioButton,    description: 'Pick one from inline options' },
  { type: 'checkbox',    label: 'Checkbox',         Icon: CheckSquare,    description: 'Single yes/no toggle' },
  { type: 'file',        label: 'File upload',      Icon: Paperclip,      description: 'Attach a file with the request' },
];

export const FIELD_BY_TYPE = Object.fromEntries(FIELD_PALETTE.map(f => [f.type, f]));

export function defaultFieldFor(type) {
  const base = {
    id: `f_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
    key: '',
    label: '',
    type,
    required: false,
    help_text: '',
    placeholder: '',
    default: '',
    options: [],
  };
  if (['select', 'multiselect', 'radio'].includes(type)) {
    base.options = [{ label: 'Option 1', value: 'option_1' }, { label: 'Option 2', value: 'option_2' }];
  }
  if (type === 'multiselect') base.multiple = true;
  if (type === 'priority') {
    base.label = 'Priority';
    base.help_text = 'How urgent is this request?';
    base.options = [
      { label: 'Low', value: 'low' },
      { label: 'Medium', value: 'medium' },
      { label: 'High', value: 'high' },
      { label: 'Urgent', value: 'urgent' },
    ];
  }
  return base;
}
